import { makeStyles } from '@material-ui/core';
import React from 'react';

export const SvgComponent = ({ src, color }: { src: string; color: string }) => {
  const [svgFile, setSvgFile] = React.useState<null | any>(null);
  const classes = useStyles(color)();

  const loadSVG = () => {
    fetch(src)
      .then((response) => {
        return response.text();
      })
      .then((svg) => {
        setSvgFile(svg);
      });
  };

  React.useEffect(() => {
    loadSVG();
  }, [src]);

  return <div dangerouslySetInnerHTML={{ __html: svgFile }} className={classes.customSvg} />;
};

const useStyles = (color: string) =>
  makeStyles({
    customSvg: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        width: '100%',
        height: '100%',
        '& path, & polygon, & rect': {
          fill: color ? color : 'currentColor'
        }
      }
    }
  });
